<template>
  <div>
    <kn-jumbotron></kn-jumbotron>
    <b-container fluid class="px-4 pb-5">
      <b-row class="justify-content-center mx-auto" style="max-width: 1400px;">
        <kn-sideMenu></kn-sideMenu>

        <main role="main" class="col-md-9 pl-md-5">
          <div class="content-card">
            <h2 class="section-title">
              <span class="blue-accent"></span>Κιμωλιακή Βιβλιοθήκη
            </h2>

            <div class="accordion-wrapper mt-4">
              <b-card no-body class="modern-accordion-card mb-3" v-for="(book, index) in books" :key="index">
                <b-card-header header-tag="header" class="p-0 border-0" role="tab">
                  <b-btn block href="#" v-b-toggle="`accordion-${index}`" class="modern-accordion-btn text-left">
                    <i class="fa-solid fa-book mr-2"></i> {{ book.title }}
                    <i class="fa-solid fa-chevron-down float-right mt-1 chevron-icon"></i>
                  </b-btn>
                </b-card-header>

                <b-collapse :id="`accordion-${index}`" accordion="my-accordion" role="tabpanel">
                  <b-card-body class="p-4 bg-light">
                    <div class="pdf-toolbar mb-3 d-flex justify-content-center justify-content-md-end">
                      <a :href="book.url" target="_blank" class="btn btn-sm btn-outline-primary pdf-btn">
                        <i class="fa-solid fa-expand mr-1"></i> Προβολή βιβλίου σε πλήρη οθόνη
                      </a>
                    </div>
                    <div class="pdf-wrapper">
                      <iframe class="modern-pdf-iframe" :src="book.url" allowfullscreen>
                      </iframe>
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>

          </div>
        </main>
      </b-row>
    </b-container>
    <kn-footer></kn-footer>
  </div>
</template>

<script>
import jumbotron from "./jumbotron.vue";
import sideMenu from "./sideMenu.vue";
import footer from "./footer.vue";

export default {
  components: {
    "kn-jumbotron": jumbotron,
    "kn-sideMenu": sideMenu,
    "kn-footer": footer
  },
  data() {
    return {
      books: [
        { title: "ΟΙ ΦΛΕΕΣ ΤΟΥ ΓΙΩΡΓΗΛΑ", url: "https://www.kimoliaka-nea.gr/vivlia/giorgilas.pdf" },
        { title: "ΚΙΜΩΛΙΑΚΩΝ ΠΑΡΟΙΜΙΩΝ ΤΟ ΑΝΑΓΝΩΣΜΑ", url: "https://www.kimoliaka-nea.gr/vivlia/kimoliakon_paroimion.pdf" },
        { title: "H ΕΚΠΑΙΔΕΥΤΙΚΗ ΑΝΟΙΞΗ ΣΤΟ ΝΗΣΙ ΤΗΣ ΚΙΜΩΛΟΥ (1823-1854)", url: "https://www.kimoliaka-nea.gr/vivlia/anoiksi.pdf" },
        { title: "ΑΝΤΩΝΙΟΣ ΒΑΣ. ΣΑΡΔΗΣ ΟΙΚΟΝΟΜΟΣ ΚΙΜΩΛΟΥ - ΦΙΛΙΚΟΣ (1772-1843)", url: "https://www.kimoliaka-nea.gr/vivlia/antonios_sardis.pdf" },
        { title: "Ο ΝΑΟΣ ΤΟΥ ΣΩΤΗΡΟΣ ΧΡΙΣΤΟΥ ΚΙΜΩΛΟΥ ΚΑΙ Ο ΠΡΕΣΒΥΤΕΡΟΣ ΜΑΡΚΟΣ Ν. ΒΕΝΤΟΥΡΗΣ", url: "https://www.kimoliaka-nea.gr/vivlia/naos_sotiros.pdf" },
        { title: "10η ΣΥΝΑΝΤΗΣΗ ΚΥΚΛΑΔΙΚΟΥ ΤΥΠΟΥ", url: "https://www.kimoliaka-nea.gr/vivlia/10_sinantisi.pdf" },
        { title: "ΕΜΕΝΑ ΜΕ ΞΕΡΟΥΝ Ο ΔΑΣΚΑΛΟΣ", url: "https://www.kimoliaka-nea.gr/vivlia/troullos.pdf" },
        { title: "ΚΙΜΩΛΙΑΚΑ ΙΣΤΟΡΙΚΑ ΘΕΜΑΤΑ", url: "https://www.kimoliaka-nea.gr/vivlia/kimoliaka_istorika.pdf" },
        { title: "ΜΙΜΗΣ ΑΝΤ. ΑΦΕΝΤΑΚΗΣ 1903-1959 - Ο Κιμώλιος ευπατρίδης και οραματιστής", url: "https://www.kimoliaka-nea.gr/vivlia/afentakis.pdf" },
        { title: "ΟΙΚΟΝΟΜΙΚΗ ΖΩΗ ΚΑΙ ΕΠΑΓΓΕΛΜΑΤΑ ΤΗΣ ΚΙΜΩΛΟΥ", url: "https://www.kimoliaka-nea.gr/vivlia/oikonomiki_zoi.pdf" },
        { title: "ΠΕΡΙ ΤΗΣ ΙΕΡΑΣ ΑΡΧΙΕΠΙΣΚΟΠΗΣ ΜΗΛΟΥ ΚΑΙ ΚΙΜΩΛΟΥ ΚΑΙ ΑΝΙΔΡΥΣΗΣ ΜΗΤΡΟΠΟΛΕΩΣ ΣΙΦΝΟΜΗΛΟΥ", url: "https://www.kimoliaka-nea.gr/vivlia/arxiepiskopi.pdf" },
        { title: "H ΑΥΤΟΔΙΟΙΚΗΣΗ ΤΗΣ ΚΙΜΩΛΟΥ Α' ΜΕΡΟΣ: 1920-1950", url: "https://www.kimoliaka-nea.gr/vivlia/autodioikisi_a.pdf" },
        { title: "H ΑΥΤΟΔΙΟΙΚΗΣΗ ΤΗΣ ΚΙΜΩΛΟΥ Β' ΜΕΡΟΣ: 1951-1982", url: "https://www.kimoliaka-nea.gr/vivlia/autodioikisi_b.pdf" },
        { title: "H ΑΥΤΟΔΙΟΙΚΗΣΗ ΤΗΣ ΚΙΜΩΛΟΥ Γ' ΜΕΡΟΣ: 1983-2010", url: "https://www.kimoliaka-nea.gr/vivlia/autodioikisi_c.pdf" },
        { title: "ΚΙΜΩΛΙΑΚΑ ΙΣΤΟΡΙΚΑ ΔΙΑΦΟΡΑ", url: "https://www.kimoliaka-nea.gr/vivlia/kimoliaka_istorika_diafora.pdf" },
        { title: "ΛΕΞΕΙΣ ΤΗΣ ΚΙΜΩΛΟΥ", url: "https://www.kimoliaka-nea.gr/vivlia/Lexeis_tis_Kimolou.pdf" }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.content-card {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 10px 25px -5px rgba(2, 132, 199, 0.1), 0 8px 10px -6px rgba(2, 132, 199, 0.05);
  /* Blue tinted shadow */
  padding: 2.5rem;
  margin-bottom: 2rem;
  border-top: 5px solid #0284c7;
  /* Greek sea blue stripe on top */
}

.section-title {
  display: flex;
  align-items: center;
  font-size: 1.75rem;
  color: #0c4a6e;
  border: none;
  margin-bottom: 1.5rem;
  font-weight: 700;
}

.blue-accent {
  background: #0ea5e9;
  /* Lighter Aegean blue */
  display: inline-block;
  width: 6px;
  height: 28px;
  margin-right: 12px;
  border-radius: 4px;
}

.modern-accordion-card {
  border: 1px solid #e0f2fe;
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(2, 132, 199, 0.05);
}

.modern-accordion-btn {
  background-color: #f8fafc !important;
  color: #0c4a6e !important;
  border: none;
  padding: 1.25rem 1.5rem;
  font-size: 1.1rem;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: none !important;
  border-radius: 0;
}

.modern-accordion-btn:hover,
.modern-accordion-btn:focus,
.modern-accordion-btn:active {
  background-color: #f0f9ff !important;
  color: #0284c7 !important;
}

.collapsed .chevron-icon {
  transform: rotate(0deg);
  transition: transform 0.3s ease;
}

.chevron-icon {
  transform: rotate(180deg);
  transition: transform 0.3s ease;
  color: #0ea5e9;
}

/* PDF Modernization Styles */
.pdf-toolbar {
  border-bottom: 1px solid #e0f2fe;
  padding-bottom: 0.5rem;
}

.pdf-btn {
  color: #0284c7;
  border-color: #0284c7;
  font-weight: 500;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.pdf-btn:hover {
  background-color: #0284c7;
  color: #ffffff;
}

@media (max-width: 767.98px) {
  .pdf-btn {
    width: 100%;
    padding: 0.6rem;
    font-size: 1rem;
  }
}

.pdf-wrapper {
  width: 100%;
  /* Books and papers scale better without thick margins */
  aspect-ratio: 1 / 1.414;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  border: 4px solid #f8fafc;
  background-color: #f1f5f9;
  position: relative;
}

/* Fallback for older browsers that don't support aspect-ratio */
@supports not (aspect-ratio: 1 / 1.414) {
  .pdf-wrapper {
    height: 80vh;
  }
}

.modern-pdf-iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/books.vue